import React from "react";
import classNames from "classnames";


const Buttons = ({ buttons }) => {

  return (
    <>
      {buttons.map(({ label, url }, index) => 
        <div className="btn-group" role="group" key={index}>
          <a href={url} className="btn btn-success-inverse">
            { i18n.t(`header.${label}`) }
          </a>
        </div>
      )}
    </>
  );
}

export default Buttons;
